import React, {Component} from 'react';
import {connect} from "react-redux";
import {getQuizResultsAction} from "../actions/quizAction";
import QuizResultListContainer from "../containers/quizResult/quizResultListContainer";
import moment from 'moment';
import QuizResultStatusContainer from "../containers/quizResult/quizResultStatusContainer";
import ModalEducationInfoComponent from "./../components/modals/modalEducationInfoComponent";
import EducationInfoComponent from "../containers/quizResult/educationInfoComponent";
import QuizStartContainer from '../containers/quizResult/quizStartContainer';
import UploadDocumentContainer from "../containers/quizResult/uploadDocumentContainer";
import QuizParticipantsContainer from "../containers/quizResult/quizParticipantsContainer";
import QuizParticipantsInfoComponent from "../components/quiz/quizParticipantsInfoComponent";
import QuizParticipantsResultComponent from "../components/quiz/quizParticipantsResultComponent";

class QuizResultPage extends Component {
    quizResults;
    quizInfo;
    quizData;
    educationDetail;

    constructor(props) {
        super(props);
        this.getData();
    }

    getData = () => {
        this.props.dispatch(getQuizResultsAction({
            session_quiz: this.props.match.params.quizSessionId,
            session_id: this.props.match.params.sessionId
        }, (res) => {
            if (res) {
                this.quizResults = res.quizResultArray;
                this.quizInfo = res.quizSessionInfo;
                this.quizData = res.quizInfo;
                this.educationDetail = res.educationDetail;
                this.sessionDetail = res.sessionDetail;
                this.isQuizExist = res.isQuizExist;
                this.participants = res.participants;
                this.sessionDocuments = res.sessionDocuments;
                this.sessionToken = res.sessionToken;
                this.forceUpdate();
            }
        }))
    };

    endSession = () => {
        this.getData();
    }

    render() {
        return (
            <div className={"mainRoot "}>

                <div className="quiz-result-root">

                    <div className="safe-area quiz-web-container">
                        <div className="content-block">
                            <div className="content-item">
                                <EducationInfoComponent educationDetail={this.educationDetail} history={this.props.history}
                                                        participants={(this.quizInfo && this.quizResults && this.quizResults.length > 0) ? this.quizResults : this.participants}
                                                        isQuizResult={this.quizInfo && this.quizResults && this.quizResults.length > 0}
                                                        endSession={this.endSession}
                                                        session_id={this.props.match.params.sessionId}
                                                        sessionDetail={this.sessionDetail}/>
                                {
                                    (this.quizInfo && this.quizResults && this.quizResults.length > 0 && this.sessionDetail.session_type!=="online") &&
                                    <QuizResultStatusContainer quizData={this.quizData} quizResults={this.quizResults} sessionDetail={this.sessionDetail}
                                                               quizInfo={this.quizInfo}/>
                                }
                                {
                                    (this.quizInfo && this.quizResults && this.quizResults.length > 0 && this.sessionDetail.session_type!=="online") &&
                                    <QuizResultListContainer quizResults={this.quizResults}
                                                             participants={this.participants}
                                                             sessionDetail={this.sessionDetail}/>
                                }
                                {
                                    this.isQuizExist !== false && (!this.quizResults || this.quizResults.length === 0) &&
                                    <QuizStartContainer history={this.props.history}
                                                        sessionDetail={this.sessionDetail}/>
                                }
                                {
                                    (this.sessionDetail && this.sessionDetail.session_type!=="online") &&
                                    <UploadDocumentContainer sessionDetail={this.sessionDetail} sessionToken={this.sessionToken}
                                                             sessionDocuments={this.sessionDocuments} getData={this.getData}
                                                             educationDetail={this.educationDetail}/>
                                }

                                {
                                    (this.sessionDetail && this.sessionDetail.session_type !== "online") &&
                                    <QuizParticipantsContainer sessionDetail={this.sessionDetail}
                                                               participants={this.participants}/>
                                }

                                {
                                    (this.sessionDetail && this.sessionDetail.session_type === "online" && !this.sessionDetail.session_end_date) &&
                                    <QuizParticipantsInfoComponent participants={this.participants} quizResults={this.quizResults}/>
                                }

                                {
                                    (this.sessionDetail && this.sessionDetail.session_type==="online" && this.sessionDetail.session_end_date) &&
                                    <QuizParticipantsResultComponent quizResults={this.quizResults}
                                                                     participants={this.participants}
                                                                     quizInfo={this.quizInfo}
                                                                     sessionDetail={this.sessionDetail}/>
                                }
                                {
                                    (this.sessionDetail && this.sessionDetail.session_type==="online" ) &&
                                    <UploadDocumentContainer sessionDetail={this.sessionDetail} sessionToken={this.sessionToken}
                                                             sessionDocuments={this.sessionDocuments} getData={this.getData}
                                                             educationDetail={this.educationDetail}/>
                                }
                            </div>


                        </div>

                    </div>


                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    isLogin: state.sessionReducer.isLogin
});

export default connect(mapStateToProps)(QuizResultPage);
